import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    id: Number,
    url: String,
    interval: { type: Number, default: 30000 } // 30 seconds
  }

  static targets = ['output']

  connect () {
    this.poll()
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect () {
    clearInterval(this.timer)
  }

  poll () {
    fetch(this.urlValue)
      .then(response => response.json())
      .then(data => {
        this.outputTarget.textContent = data.online ? 'Online' : 'Offline'
        this.outputTarget.classList.remove('text-yellow-600', 'text-green-600', 'text-red-600')
        this.outputTarget.classList.add(data.online ? 'text-green-600' : 'text-red-600')
      })
      .catch(() => {
        this.outputTarget.textContent = 'Error'
        this.outputTarget.classList.remove('text-green-600', 'text-red-600')
        this.outputTarget.classList.add('text-yellow-600')
      })
  }
}
